(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["norla-datalayer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__norlaDataLayer) return;
    window.__norlaDataLayer = true;

    var dl = function (payload) {
      window.dataLayer = window.dataLayer || [];
      // Clear the previous ecommerce object first, otherwise GA4 merges the
      // old items array into the new event.
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
    };

    var money = function (cents) {
      return typeof cents === 'number' ? Math.round(cents) / 100 : undefined;
    };

    var lineToItem = function (line) {
      return {
        item_id: line.sku || String(line.variant_id || ''),
        item_name: line.product_title || line.title,
        item_brand: line.vendor,
        item_variant: line.variant_title || undefined,
        price: money(line.final_price != null ? line.final_price : line.price),
        quantity: line.quantity
      };
    };

    // add_to_cart — the theme fires `cart:update` for both a successful add and
    // a failed one, so failures are filtered out via detail.data.didError.
    document.addEventListener('cart:update', function (event) {
      var detail = event.detail || {};
      var data = detail.data || {};
      if (data.didError) return;
      if (data.source !== 'product-form-component' && data.source !== 'quick-add-component') return;

      var cart = detail.resource;
      if (!cart || !cart.items) return;

      // The cart object is the whole cart, so pick out the line that was just
      // added rather than reporting every line as newly added.
      var line = null;
      if (data.variantId) {
        line = cart.items.filter(function (i) { return String(i.variant_id) === String(data.variantId); })[0];
      }
      if (!line && data.productId) {
        line = cart.items.filter(function (i) { return String(i.product_id) === String(data.productId); })[0];
      }
      if (!line) line = cart.items[cart.items.length - 1];
      if (!line) return;

      var item = lineToItem(line);
      var qty = data.itemCount || 1;
      item.quantity = qty;

      dl({
        event: 'add_to_cart',
        ecommerce: {
          currency: cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active),
          value: (item.price || 0) * qty,
          items: [item]
        }
      });
    });

    // begin_checkout — covers the drawer button, the cart page form and the
    // accelerated wallet buttons, all of which submit to /checkout.
    var checkoutPushed = false;
    var pushBeginCheckout = function () {
      if (checkoutPushed) return;
      checkoutPushed = true;
      // Reset shortly after, so a customer who returns and checks out again
      // in the same page view is still measured.
      setTimeout(function () { checkoutPushed = false; }, 3000);

      fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_url ? window.Theme.routes.cart_url : '/cart') + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          dl({
            event: 'begin_checkout',
            ecommerce: {
              currency: cart.currency,
              value: money(cart.total_price),
              items: cart.items.map(lineToItem)
            }
          });
        })
        .catch(function () {
          /* measurement must never block the customer reaching checkout */
        });
    };

    document.addEventListener(
      'click',
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        if (
          t.closest('[name="checkout"]') ||
          t.closest('.cart__checkout-button') ||
          t.closest('shopify-accelerated-checkout') ||
          t.closest('.shopify-payment-button')
        ) {
          pushBeginCheckout();
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["norla-gift-picker"] && !Shopify.designMode) return;
  try {
    // Adds the chosen gift, then tells the theme's cart components to refresh by
  // dispatching the same 'cart:update' event they already listen for. The line
  // property is what makes the gift readable as a gift in the admin.
  class NorlaGiftPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = async (event) => {
      const button = event.target.closest('[data-variant-id]');
      if (!button || button.disabled) return;

      const error = this.querySelector('[ref="error"]');
      error?.classList.add('hidden');
      button.disabled = true;

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: Number(button.dataset.variantId),
                quantity: 1,
                properties: { _gift: button.dataset.title },
              },
            ],
          }),
        });

        if (!response.ok) throw new Error(`Cart responded ${response.status}`);
        await response.json();

        const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());

        const updated = new Event('cart:update', { bubbles: true });
        updated.detail = {
          resource: cart,
          sourceId: 'norla-gift-picker',
          data: { source: 'norla-gift-picker' },
        };
        document.dispatchEvent(updated);
      } catch (err) {
        console.error(err);
        error?.classList.remove('hidden');
        button.disabled = false;
      }
    };
  }

  if (!customElements.get('norla-gift-picker')) {
    customElements.define('norla-gift-picker', NorlaGiftPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["norla-locale-suggest"] && !Shopify.designMode) return;
  try {
    (function () {
    var banner = document.getElementById('nrl-locale');
    if (!banner) return;

    var STORAGE_KEY = 'nrl-locale-choice';
    var targetCountry = banner.dataset.targetCountry;
    var targetOrigin = banner.dataset.targetOrigin;

    function remembered() {
      try {
        return window.localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        return null;
      }
    }

    function remember(value) {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (e) {
        /* private browsing — the banner simply reappears next visit */
      }
    }

    // Deliberately a plain navigation rather than a /localization form post.
    // The NL market spans two domains, and switching locale keeps the visitor
    // on whichever one they are already on — so the form would land them on
    // shopnorla.com/nl while the banner promised norla.nl.
    function goToDutchSite() {
      var root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
      var path = window.location.pathname;

      // Strip any locale prefix (/fr/, /nl/) so the path maps onto norla.nl,
      // which serves Dutch at its root.
      if (root !== '/' && path.indexOf(root) === 0) {
        path = '/' + path.slice(root.length);
      }

      window.location.assign(targetOrigin + path + window.location.search);
    }

    // Deliberately no check on window.Shopify.country here: a visitor in the
    // Netherlands is already on the NL market while still being served English,
    // which is exactly the case this banner exists for. The Liquid guard above
    // is what suppresses the banner once country AND language are both Dutch.
    if (remembered() || !window.Shopify || !window.Shopify.routes) return;

    fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country;
        if (!detected || detected.handle !== targetCountry) return;

        banner.hidden = false;

        banner.querySelector('[data-nrl-locale-accept]').addEventListener('click', function () {
          remember('nl');
          goToDutchSite();
        });

        banner.querySelector('[data-nrl-locale-decline]').addEventListener('click', function () {
          remember('stay');
          banner.hidden = true;
        });
      })
      .catch(function () {
        /* detection unavailable — leave the visitor where they are */
      });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["norla-personalization-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var el = document.querySelector('[data-nrl-perso]');
    if (!el) return;

    var SEEN_KEY = 'nrl_seen';
    var DISMISS_KEY = 'nrl_perso_dismissed';

    try {
      if (sessionStorage.getItem(DISMISS_KEY) === '1') return;
    } catch (e) {}

    var textEl = el.querySelector('.nrl-perso__text');
    var ctaEl = el.querySelector('.nrl-perso__cta');
    var closeEl = el.querySelector('.nrl-perso__close');

    function show() {
      // Never reveal a bar without a message. Guards against a missing
      // message attribute or an empty translation leaving a bare strip
      // with only the close button on screen.
      if (!textEl || textEl.textContent.trim() === '') return;
      el.hidden = false;
    }

    if (closeEl) {
      closeEl.addEventListener('click', function () {
        el.hidden = true;
        try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
      });
    }

    if (el.getAttribute('data-server-state') === 'cart') {
      show();
      markSeen();
      return;
    }

    var SOURCES = {
      tiktok: 'TikTok',
      instagram: 'Instagram',
      facebook: 'Facebook',
      pinterest: 'Pinterest',
      youtube: 'YouTube'
    };

    var source = detectSource();

    if (source) {
      var campaignTpl = el.getAttribute('data-msg-campaign') || '';
      textEl.innerHTML = campaignTpl.replace('[source]', source);
      setShopCta();
      show();
      markSeen();
      return;
    }

    var isReturning = false;
    try {
      isReturning = localStorage.getItem(SEEN_KEY) === '1';
    } catch (e) {}

    if (isReturning) {
      textEl.innerHTML = el.getAttribute('data-msg-returning') || '';
      setShopCta();
      show();
    }

    markSeen();

    function setShopCta() {
      var label = el.getAttribute('data-cta-shop') || '';
      var url = el.getAttribute('data-shop-url') || '';
      if (ctaEl && label && url) {
        ctaEl.textContent = label;
        ctaEl.setAttribute('href', url);
      }
    }

    function markSeen() {
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    }

    function detectSource() {
      var found = '';
      try {
        found = sessionStorage.getItem('nrl_source') || '';
        if (found) return found;

        var params = new URLSearchParams(window.location.search);
        var utm = (params.get('utm_source') || '').toLowerCase();
        var ref = (document.referrer || '').toLowerCase();

        for (var key in SOURCES) {
          if (utm.indexOf(key) !== -1 || ref.indexOf(key) !== -1) {
            found = SOURCES[key];
            break;
          }
        }
        if (found) sessionStorage.setItem('nrl_source', found);
      } catch (e) {}
      return found;
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oriluxe-celebrate"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__olxCelebrate) return;
    window.__olxCelebrate = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var colors = ['#B08D57', '#C9A961', '#EFEBE3', '#2A2622', '#E8C9B0', '#9C7A4E'];
    var lastFire = 0;

    function launch() {
      if (reduce) return;
      var now = Date.now();
      if (now - lastFire < 700) return; // de-dupe click + submit
      lastFire = now;

      var layer = document.createElement('div');
      layer.className = 'olx-balloons';
      document.body.appendChild(layer);

      var count = 14;
      for (var i = 0; i < count; i++) {
        var b = document.createElement('div');
        b.className = 'olx-balloon';
        b.style.setProperty('--x', (Math.random() * 100) + 'vw');
        b.style.setProperty('--dur', (2.6 + Math.random() * 1.6) + 's');
        b.style.setProperty('--delay', (Math.random() * 0.45) + 's');
        b.style.setProperty('--size', (26 + Math.random() * 22) + 'px');
        b.style.setProperty('--sway', (Math.random() * 44 - 22) + 'px');
        b.style.setProperty('--c', colors[i % colors.length]);
        layer.appendChild(b);
      }
      setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 4800);
    }
    // Expose for manual triggering if ever needed
    window.olxLaunchBalloons = launch;

    function isAddToCart(target) {
      var el = target.closest ? target.closest('button, input[type="submit"], a') : null;
      if (!el) return false;
      if (el.matches('[name="add"], [data-add-to-cart], .product-form__submit, .quick-add__submit, .add-to-cart, .a-product-form__cart-submit, add-to-cart-component button')) {
        return true;
      }
      var form = el.closest('form');
      if (form && /\/cart\/add/.test(form.getAttribute('action') || '')) return true;
      var text = (el.textContent || '').toLowerCase();
      if (text.indexOf('add to cart') > -1 || text.indexOf('add to bag') > -1) return true;
      return false;
    }

    // Trigger on click (what the customer actually does)
    document.addEventListener('click', function (e) {
      try { if (isAddToCart(e.target)) launch(); } catch (err) {}
    }, true);

    // Trigger on any /cart/add form submit (keyboard / programmatic)
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) launch();
    }, true);

    // Best-effort: Shopify AJAX cart success events (varies by theme)
    ['cart:added', 'cart:add', 'product:added', 'on:cart:add'].forEach(function (ev) {
      document.addEventListener(ev, launch);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oriluxe-exit-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__olxExitInit) return;
    window.__olxExitInit = true;
    var KEY = 'olx_exit_seen';
    function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
    function markSeen() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

    function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
    ready(function () {
      var modal = document.querySelector('[data-olx-exit]');
      if (!modal) return;

      // Never interrupt someone who is deciding on a product, or who already
      // has something in their bag. The bar competes with the buy button and
      // sends them off hunting for the discount code it advertises.
      var suppressed = modal.dataset.suppress === 'true';
      // If the form was just submitted successfully, show it so the success state is visible.
      var justSubmitted = modal.querySelector('.olx-exit__success');
      if (seen() && !justSubmitted) return;
      if (suppressed && !justSubmitted) return;

      var lastFocused = null;
      function focusable() {
        return Array.prototype.slice.call(
          modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
        );
      }
      function trapKeydown(e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var items = focusable();
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }

      function open() {
        if (seen() && !justSubmitted) return;
        lastFocused = document.activeElement;
        modal.hidden = false; modal.setAttribute('aria-hidden', 'false');
        markSeen();
        document.removeEventListener('mouseout', onOut);
        var items = focusable();
        if (items.length) items[0].focus();
        document.addEventListener('keydown', trapKeydown);
      }
      function close() {
        modal.hidden = true; modal.setAttribute('aria-hidden', 'true');
        document.removeEventListener('keydown', trapKeydown);
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }

      modal.querySelectorAll('[data-olx-exit-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });

      if (justSubmitted) {
        modal.hidden = false;
        var items = focusable();
        if (items.length) items[0].focus();
        document.addEventListener('keydown', trapKeydown);
        return;
      }

      // Desktop: exit intent (cursor leaves toward the top)
      function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 4) open();
      }
      document.addEventListener('mouseout', onOut);

      // Touch devices have no exit intent, so they get a timer instead - but a
      // long one. At 25s it landed exactly on the moment of decision and covered
      // the add-to-cart button.
      var isTouch = 'ontouchstart' in window && navigator.maxTouchPoints > 0;
      if (isTouch) {
        setTimeout(function () { if (!seen()) open(); }, 60000);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
